__webpack_require__.p = "/skeleton-fe/";